import { types } from "./types";

const SearchReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SUGGESTIONSLOADED_SUCCES:
      return action.payload;
    case types.SET_SUGGESTIONS_DATA:
      return action.payload;
    case types.SET_PLACES:
      return action.payload;
    case types.SET_SEARCH_INPUT:
      return action.payload;
    case types.SET_DETAILS:
      return action.payload;
    case types.SET_DETAILS_LOADED_SUCCES:
      return action.payload;
    case types.SET_SEARCH_INPUT_VIA_STORAGE:
      return action.payload;
    case types.SET_RADIUS_DISTANCE:
      return action.payload;
    case types.SET_QUALITY_SCHEME:
      return action.payload;
    default:
      return state;
  }
};

export { SearchReducer };
